export default {
  header: 'Menu',
  tabs: {
    menu: 'Menu',
    modifier_groups: 'Modificateurs',
  },
  toasts: {
    failed_to_load_data: 'Impossible de charger le menu. Veuillez actualiser et réessayer',
  },
};
